export default __webpack_public_path__ + "static/media/locomotive.0059a48a.png";